import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var CircleShape = /*#__PURE__*/function () {
  function CircleShape() {
    _classCallCheck(this, CircleShape);
  }
  _createClass(CircleShape, [{
    key: "randomPosition",
    value: function randomPosition(position, size, fill) {
      var generateTheta = function generateTheta(x, y) {
          var u = Math.random() / 4.0,
            theta = Math.atan(y / x * Math.tan(2 * Math.PI * u)),
            v = Math.random();
          if (v < 0.25) {
            return theta;
          } else if (v < 0.5) {
            return Math.PI - theta;
          } else if (v < 0.75) {
            return Math.PI + theta;
          } else {
            return -theta;
          }
        },
        radius = function radius(x, y, theta) {
          return x * y / Math.sqrt(Math.pow(y * Math.cos(theta), 2) + Math.pow(x * Math.sin(theta), 2));
        },
        a = size.width / 2,
        b = size.height / 2,
        randomTheta = generateTheta(a, b),
        maxRadius = radius(a, b, randomTheta),
        randomRadius = fill ? maxRadius * Math.sqrt(Math.random()) : maxRadius;
      return {
        x: position.x + randomRadius * Math.cos(randomTheta),
        y: position.y + randomRadius * Math.sin(randomTheta)
      };
    }
  }]);
  return CircleShape;
}();